import React, { useEffect, useRef, useState } from 'react';
import { Accordion, Col, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import AboutMainImage from '../../assets/AboutPageImages/AboutMainImage.png';
import AboutPageImage from '../../assets/AboutPageImages/AboutPageImage.png';
import './AboutPage.css';
import CardsComponent from '../HomePage/CardsComponent/CardsComponent';
import LogosComponent from '../HomePage/LogosComponent/LogosComponent';
import { Helmet } from 'react-helmet';

const reviews = [
  { question: 'What roofing services does Ultimates Roofing provide?', 
    answer: 'Ultimates Roofing offers roof installation, replacement, repairs, inspections, and maintenance for residential and commercial properties.' },
  { question: 'How experienced is Ultimates Roofing in the industry?',
   answer: 'Ultimates Roofing has several 12+ years of hands-on experience, delivering reliable roofing solutions backed by skilled professionals.' },
  { question: 'What sets Ultimates Roofing apart from other roofing companies?',
   answer: 'They focus on quality craftsmanship, timely service, transparent pricing, and customer satisfaction, making them a trusted choice in the industry.' },
  { question: ' How can I request an estimate for my roofing project?', 
    answer: 'You can request a free estimate by calling their office, filling out the contact form on their website, or emailing them directly.' },
 
  { question: 'Can Ultimates Roofing handle emergency repairs?', 
    answer: 'Yes, they offer emergency roofing repair services to address urgent leaks, storm damage, or other immediate concerns.' },
  { question: 'What types of roofing materials does Ultimates Roofing use?', 
    answer: 'They work with a variety of materials, including asphalt shingles, metal roofing, tile, slate, and flat roofing systems.' },
     { question: ' Does Ultimates Roofing provide warranties for its services?',
     answer: 'Yes, they provide workmanship warranties along with manufacturer warranties on roofing materials for peace of mind.' },
]

function AboutPage() {
  const navigate = useNavigate();
  const [countExperience, setCountExperience] = useState(0);
  const [countWarranty, setCountWarranty] = useState(0);
  const [countWarranty1, setCountWarranty1] = useState(0);
  const [countQuality, setCountQuality] = useState(0);
  const [isIntersecting, setIsIntersecting] = useState(false);
  const countingRef = useRef(null);

  // Intersection observer callback
  const handleIntersection = (entries) => {
    const entry = entries[0];
    setIsIntersecting(entry.isIntersecting);
  };

  // Effect to set up the intersection observer
  useEffect(() => {
    const options = {
      threshold: 0.5, // Adjust as needed
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    if (countingRef.current) {
      observer.observe(countingRef.current);
    }

    return () => {
      if (countingRef.current) {
         // eslint-disable-next-line
        observer.unobserve(countingRef.current);
      }
    };
  }, []);

  // Effect to count experience and warranty years
  useEffect(() => {
    if (isIntersecting) {
      const intervalExperience = setInterval(() => {
        setCountExperience((prevCount) => (prevCount < 15 ? prevCount + 1 : prevCount));
      }, 200);

      const intervalWarranty = setInterval(() => {
        setCountWarranty((prevCount) => (prevCount < 20 ? prevCount + 1 : prevCount));
      }, 200);

      const intervalWarranty1 = setInterval(() => {
        setCountWarranty1((prevCount) => (prevCount < 25 ? prevCount + 1 : prevCount));
      }, 200);

      const intervalQuality = setInterval(() => {
        setCountQuality((prevCount) => (prevCount < 100 ? prevCount + 2 : prevCount));
      }, 200);

      return () => {
        clearInterval(intervalExperience);
        clearInterval(intervalWarranty);
        clearInterval(intervalWarranty1);
        clearInterval(intervalQuality);
      };
    }
  }, [isIntersecting, countExperience, countWarranty, countWarranty1, countQuality]);

  // Effect to scroll to the top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* Helmet component for SEO meta tags */}
      <Helmet>
        <title>Ultimates Roofing LLC-About Us</title>
        <link rel="canonical" href="https://www.ultimatesroofing.com/about" />
        <meta name='description' content='Learn more about Ultimates Roofing LLC - Your trusted partner for residential roofing, commercial roofing, siding, windows, and gutters. Discover our commitment to excellence and dedication to providing top-notch construction and home improvement services.' />
        <meta name='keywords' content='Ultimates Roofing llc, Ultimates Roofing, Best Roofing design in columbus,ohio, Best Roofing Companies in columbus ohio, ultimates roof replacement near me, best roofing designs for small houses, best roofing drip edge, best roof columbus, best roofing company near me, ultimates roof replacement columbus ohio, 
        best roofing company, ultimates roof repair columbus ohio, affordable roof, eplacement services in columbus,ohio, luxury home roofing solutions near me, roof repair, Roofer near me, roofing repairs near me, roofing sheet' />
         <meta name='author' content='Ultimates Roofing LLC' />
        <meta name='robots' content='index, follow' />
        <html lang="en" />
      </Helmet>

      {/* About Main Section */}
      <div className='about-main'>
        <p className='about-us'><span style={{ color: "#B22335", fontWeight: "bold" }}>I</span> About Us</p>
        <h2 className='about-page-heading'>Ultimates Roofing LLC</h2>
        <p className='about-page-text'>
          Founded in 2019, Ultimates Roofing LLC is a trusted provider of high-quality roofing solutions for <span> 
          <Link to="/" className='text-decoration-none color'>
          residential and commercial clients across Ohio</Link>  </span>
             and surrounding regions. With nearly a decade of industry experience, 
             <span> 
               <Link to="/our-team" className='text-decoration-none color'>  our team </Link>
                </span>
             has built a strong reputation for excellence, reliability, and unmatched
            craftsmanship.

        </p>
           
        <p className='about-page-text'>
         We offer a comprehensive range of services, including new roof installations, full roof replacements, and precision repairs. Each project is 
         executed with meticulous attention to detail, ensuring long-lasting results and complete customer satisfaction.

At Ultimates Roofing LLC, we are dedicated not only to delivering superior roofing services but also to fostering lasting relationships with our clients.
 Our mission is to provide dependable solutions that inspire confidence and deliver peace of mind.
           </p>

        <div className='image-container'>
          <img src={AboutMainImage} className='about-main-image' alt='Ultimates Roofing LLC building' />
        </div>
      </div>

      {/**  Cards Component */}
      <CardsComponent />

      <div className='about-main1'>
        <Row className='about-experience-text'>
          <Col>
            <img className='work-image' src={AboutPageImage} alt='Ultimates Roofing LLC work in progress' />
          </Col>
          <Col className='work-text'>
            <p className='about-page-text'>As the driving force behind Ultimates Roofing LLC, our company brings a wealth of passion and expertise to the roofing industry. With a background rooted in a genuine love for craftsmanship and a commitment to elevating properties, our journey began nearly a decade ago.</p>
            <p className='about-page-text'>Driven by a vision to redefine roofing solutions, our team has tirelessly led the company towards excellence. Ultimates Roofing is not just a business; it's a manifestation of our dedication to delivering top-tier services that go beyond industry standards.</p>
            <p className='about-page-text'>Under our leadership, Ultimates Roofing has become synonymous with quality, innovation, and customer satisfaction. Our commitment to integrity, community, and the highest standards of craftsmanship reflects our unwavering belief that every  <span> <Link to="/projects" className='text-decoration-none color'> roofing project </Link></span> is an opportunity to make a lasting impact.</p>
            <Row className='work-details'>
              <Col>
                <div className='number-details' ref={countingRef}>{isIntersecting ? `${countExperience}+` : ''}</div>
                <div className='work-experience'>Years of Experience</div>
              </Col>
              <Col>
                <div className='number-details' ref={countingRef}>{isIntersecting ? countWarranty : ''} - {isIntersecting ? countWarranty1 : ''}</div>
                <div className='work-experience'>Years of Warranty</div>
              </Col>
              <Col>
                <div className='number-details' >{isIntersecting ? countQuality : ''}%</div>
                <div className='work-experience'>Quality Products</div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      {/* Quick Answers Section */}
      <div className='about-main'>
        <Row className='about-experience-text'>
          <Col>
            <h2 className='about-page-heading1'>Quick Answers to Questions you may have </h2>
            <p className='about-page-text'>Couldn’t find what you are looking for? <span style={{ color: "#B22335", cursor: "pointer" }} onClick={() => { navigate('/contact') }}>Contact Us</span></p>
          </Col>
          <Col className='work-text1'>
            <Accordion defaultActiveKey="0">
              {reviews.map((review, index) => (
                <Accordion.Item key={index} eventKey={index.toString()}>
                  <Accordion.Header>{review.question}</Accordion.Header>
                  <Accordion.Body>
                    <p className="answer">{review.answer}</p>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </div>

      {/* Logos Component */}
      <LogosComponent />
    </div>
  )
}

export default AboutPage